export function getCommandBarStyles(props) {
    var theme = props.theme;
    var effects = theme.effects;
    var styles = {
        root: {
            height: '48px',
            borderRadius: effects.roundedCorner8,
            alignItems: 'center',
        },
        primarySet: {
            height: '40px',
        },
        secondarySet: {
            height: '40px',
        },
    };
    return styles;
}
//# sourceMappingURL=CommandBar.styles.js.map